import { ProductCatalogResponse } from '@/shared/state/api/swagger';

export const selectProductOptions = (products: ProductCatalogResponse[] = []) =>
	products.map((product) => ({
		value: product.id,
		label: `${product.symbol || 'Нет обозначения'} (${product.name || '-'})`,
	})) || [{ value: 0, label: '' }];
